import React from "react";
import { ComboRateChart } from "src/components/common/chart/ComboRateChart";
import { PRD5030_R01ResultDto } from "./Dto_PRD5030_R01";

interface Props {
	data: PRD5030_R01ResultDto[];
}

// 월별 시간가동율 콤보차트 컴포넌트 (막대 2개 + 선 1개 공용 컴포넌트 사용)
export const Chart_PRD5030_R01: React.FC<Props> = ({ data }) => {
	return (
		<ComboRateChart
			data={data}
			barSeries={[
				{ field: "workMin", label: "작업시간", color: "#3B82F6" },
				{ field: "downMin", label: "비가동시간", color: "#FB923C" },
			]}
			lineSeries={{ field: "operatingRate", label: "시간가동율", color: "#EF4444" }}
			y1={{ min: 70, max: 100 }}
		/>
	);
};
